export enum PositionsOptionsColumnsEnum {
	option = 'option',
	marketValue = 'marketValue',
	quantity = 'quantity',
	priceAveragePrice = 'priceAveragePrice',
	share = 'share',
	profitabilityPerDay = 'profitabilityPerDay',
	profitability = 'profitability',
}
